import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import LayoutContainer from 'Components/LayoutComponent'
import Loader from 'Components/Loader'
import { ROUTE_STRINGS, TABLE_CONST } from 'Utils/Constants'
import apiAdapterCoffeeWeb from 'Services/apiAdapterCoffeeWeb'
import { commonMethods } from 'Utils/commonMethods'
import { DialogModal } from 'Components/UIComponents'

const ListCoffeeCastEpisode = ({ setLoading }) => {
  const history = useHistory()

  const { t } = useTranslation()
  let rowCount = 8
  let paginationButtons = TABLE_CONST.paginationButtonCount

  const [windowSize, setWindowSize] = useState(window.innerWidth)
  const [coffeeCastVideos, setCoffeeCastVideos] = useState([])
  const [page, setPage] = useState(0)
  const [rows, setRows] = useState(7)
  const [totalRecords, setTotalRecords] = useState(0)
  const [showDialog, setShowDialog] = useState({ showModal: false, modalType: '', message: '', onHide: () => {}, onRetry: () => {}, onConfirmation: () => {}, onSuccess: () => {} })

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  useEffect(() => {
    fetchCoffeeCastVideos(page, rows)
  }, [page, rows])

  const fetchCoffeeCastVideos = async (pageNo, pageSize) => {
    setLoading(true)

    try {
      const { data } = await apiAdapterCoffeeWeb.getAllCoffeeCastList(pageNo, pageSize)
      const response = data.content

      setCoffeeCastVideos(response)
      setTotalRecords(data.totalElements)
    } catch (error) {
      setShowDialog({
        ...showDialog,
        showModal: true,
        modalType: 'error',
        message: t('FAILED_TO_FETCH_COFFEE_CAST_VIDEOS'),
        onHide: handleDismiss
      })
    } finally {
      setLoading(false)
    }
  }

  if (windowSize < TABLE_CONST.maxWidthTab) {
    rowCount = TABLE_CONST.mobileRowCount
    paginationButtons = TABLE_CONST.mobilePaginationButtonCount
  }

  const handleWindowResize = () => {
    setWindowSize(window.innerWidth)
  }

  const handleAddButtonClick = () => {
    history.push({
      pathname: ROUTE_STRINGS.addCoffeeCast
    })
  }

  const handleDismiss = () => {
    setShowDialog({ ...showDialog, showModal: false })
  }

  // Commented for future reference
  // const handleEdit = (rowData) => {
  //   // Implement edit functionality here
  // }

  // const handleDelete = (rowData) => {
  //   // Implement delete functionality here
  // }

  // const renderActionButtons = (rowData) => (
  //   <div className="coffee-cast-action-buttons">
  //     <Button type="button" icon="pi pi-pencil" className="edit-button" tooltip={t('EDIT')} tooltipOptions={{ position: 'top' }} onClick={() => handleEdit(rowData)} />
  //     <Button type="button" icon="pi pi-trash" className="delete-button" tooltip={t('DELETE')} tooltipOptions={{ position: 'top' }} onClick={() => handleDelete(rowData)} />
  //   </div>
  // )

  const coffeeCastTableColumns = [
    {
      dataField: 'authorChannelName',
      text: t('CHANNEL_NAME'),
      className: 'channel-column'
    },
    {
      dataField: 'country',
      text: t('COUNTRY'),
      className: 'country-column'
    },
    {
      dataField: 'createdAt',
      text: t('UPLOADED'),
      className: 'uploaded-time-column',
      body: (rowData) => commonMethods.utcToLocalTime(rowData.createdAt)
    },
    {
      dataField: 'content',
      text: t('VIDEO_DESCRIPTION'),
      className: 'video-description-column'
    },
    {
      dataField: 'videoDurationSeconds',
      text: t('VIDEO_LENGTH'),
      className: 'video-duration-column'
    }

    // commented for future reference
    // {
    //   text: t('ACTIONS'),
    //   className: 'actions-column',
    //   body: renderActionButtons
    // }
  ]

  return (
    <LayoutContainer title={t('COFFEE_CAST')} breadCrumbsTitle={'coffeeCast'} showAddButton={true} handleAddButtonClick={handleAddButtonClick}>
      <div className="coffee-cast-table-container">
        <DataTable
          value={coffeeCastVideos}
          paginator
          lazy
          first={page * rows}
          rows={rows}
          totalRecords={totalRecords}
          pageLinkSize={paginationButtons}
          onPage={(e) => {
            setPage(e.page)
            setRows(e.rows)
          }}
        >
          {coffeeCastTableColumns?.map((column, index) => (
            <Column key={index} field={column.dataField} header={column.text} body={column.body} className={column.className} />
          ))}
        </DataTable>
      </div>

      <DialogModal {...showDialog} onDismiss={handleDismiss} />
    </LayoutContainer>
  )
}

export default Loader(ListCoffeeCastEpisode)
